import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { RateSeasonService } from '../rate-season.service';
import { RateSeason } from '../rate-season';
import { RateBucketsService } from '../../rate-bucket/rate-bucket.service';

@Component({
    selector: 'app-rateSeason',
    templateUrl: './rate-season.component.html',
    styleUrls: ['./rate-season.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class RateSeasonComponent implements OnInit {
	categories: any;
	rateBuckets: any[]=[];
	formReadOnly = false;
	locationIds: any[];
	selectedTabIndex: number = 0;

	constructor(
		private primengConfig: PrimeNGConfig,
		private rateSeasonService: RateSeasonService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private rateBucketService: RateBucketsService,
		private constantService: ConstantService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.rateSeason = data.rateSeason,
			this.rateSeasonId = data.rateSeasonId,
			this.selectedTabIndex = data?.selectedTabIndex !== undefined ? data.selectedTabIndex : 0;
			this.statuses = rateSeasonService.statuses;
			this.categories = rateSeasonService.categories;
			this.locationIds = this.constantService.locations;
			// Build form here in the constructor — NOT in ngOnInit.
			// Angular Material 21's matSliderThumb directive calls writeValue() during
			// its own initialization which can fire before ngOnInit runs inside a
			// MatDialog, leaving form1 null and blanking the entire dialog.
			// Constructing the group here guarantees form1 is ready for any lifecycle.
			this.formBuild();
	}

	@Input() rateSeason: RateSeason;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	rateSeasonId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;


	rateBucketTypes = [
		{ value: 1, name: 'Auto' },
		{ value: 2, name: 'Manual' }
	];


	seasonCategories = [
		{ value: 1, name: 'Low' },
		{ value: 2, name: 'Low-Medium' },
		{ value: 3, name: 'Medium' },
		{ value: 4, name: 'Medium-High' },
		{ value: 5, name: 'High' },
	];


	discountAlorithms = [
		{ value: '1', name: 'Straight Line' },
	];

	validationMessages = {
		rateSeasonId: [],
		name: [],
		description: [],
		publicRateDesc: [],
		type: [],
		startDate: [],
		endDate: [],
		listPriceAMT: [],
		listPriceAdjustAMT: [],
		listPriceAdjustPCT: [],
		mondayAdjPCT: [],
		tuesdayAdjPCT: [],
		wednesdayAdjPCT: [],
		thursdayAdjPCT: [],
		fridayAdjPCT: [],
		saturdayAdjPCT: [],
		sundayAdjPCT: [],
		floorRateManagerAMT: [],
		floorRateOwnerAMT: [],
		category: [],
		expectedOccupancyPCT: [],
		maxDiscountPCT: [],
		discountLookForwardDays: [],
		discountLookForwardHeadlineDays: [],
		discountLookForwardHeadlineMinNightsDays: [],
		// Integer discountIntervalDays: [],
		// Integer discountCombinationDays: [],
		discountAlorithm: [],
		minStayExpectedNTS: [],
		maxStayExpectedNTS: [],
		avgStayBySeasonNTS: [],
		shortTermGapMultiplierPCT: [],
		shortTermGapPenaltyPCT: [],
		shortTermGapMinNumNightsRevNTS: [],
		longTermGapMultiplierPCT: [],
		longTermGapPenaltyPCT: [],
		longTermGapEmptyMultiplierPCT: [],
		longTermGapEmptyPenaltyPCT: [],
		connectingFrontOrBackMultiplierPCT: [],
		connectingFrontAndBackMultiplierPCT: [],
		lengthOfStayDiscountFactorOffset: [],
		rateBucketId: []
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		// formBuild() is called in the constructor — do not call it again here.
		this.getAllRateBuckets();

		// if we were passed the whole rateSeason object
		if (this.rateSeason) {
			this.rateSeasonId = this.rateSeason.rateSeasonId;
			// if(this.rateSeason.startDate != undefined && this.rateSeason.startDate != null){
			// 	this.rateSeason.startDate = moment(this.rateSeason.startDate).toDate();
			// }
			// if(this.rateSeason.endDate != undefined && this.rateSeason.endDate != null){
			// 	this.rateSeason.endDate = moment(this.rateSeason.endDate).toDate();
			// }
			// this.fixDates();
			this.form1.patchValue(this.rateSeason);
		}
		// if we were passed just the rateSeasonId (ie from Advertised Rates form), get the object
		else if (this.rateSeasonId)
		{
			this.findRateSeasonById(this.rateSeasonId);
		}
	}

	findRateSeasonById(rateSeasonId)
	{
		try
		{
			this.rateSeasonService.findById(rateSeasonId)
				.subscribe(
					res =>
					{
						this.rateSeason = res.data.rateSeason;
						this.form1.patchValue(this.rateSeason);
					},
					err =>
					{
						console.log('findRateBucketDetailById FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.rateSeasonId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.rateSeasonService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.rateSeason = res.data.rateSeason;
						this.doAdd.emit(this.rateSeason);
					},
					(err: any) => {
						console.log('rateSeason-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('rateSeason: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.rateSeasonService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.rateSeason = res.data.rateSeason;
						this.doUpdate.emit(this.rateSeason);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.rateSeasonService.delete(this.rateSeason.rateSeasonId)
				.subscribe(
					(res: any) => {
						console.log('rateSeason-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.rateSeason);
					},
					(err: any) => {
						console.log('rateSeason-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			rateSeasonId: [],
			name: [],
			description: [],
			publicRateDesc: [],
			type: [],
			startDate: [],
			endDate: [],
			listPriceAMT: [],
			listPriceAdjustAMT: [],
			listPriceAdjustPCT: [],
			mondayAdjPCT: [],
			tuesdayAdjPCT: [],
			wednesdayAdjPCT: [],
			thursdayAdjPCT: [],
			fridayAdjPCT: [],
			saturdayAdjPCT: [],
			sundayAdjPCT: [],
			floorRateManagerAMT: [],
			floorRateOwnerAMT: [],
			category: [],
			expectedOccupancyPCT: [],
			maxDiscountPCT: [],
			discountLookForwardDays: [],
			discountLookForwardHeadlineDays: [],
			discountLookForwardHeadlineMinNightsDays: [],
			// Integer discountIntervalDays: [],
			// Integer discountCombinationDays: [],
			discountAlorithm: [],
			minStayExpectedNTS: [],
			maxStayExpectedNTS: [],
			avgStayBySeasonNTS: [],
			shortTermGapMultiplierPCT: [],
			shortTermGapPenaltyPCT: [],
			shortTermGapMinNumNightsRevNTS: [],
			longTermGapMultiplierPCT: [],
			longTermGapPenaltyPCT: [],
			longTermGapEmptyMultiplierPCT: [],
			longTermGapEmptyPenaltyPCT: [],
			connectingFrontOrBackMultiplierPCT: [],
			connectingFrontAndBackMultiplierPCT: [],
			lengthOfStayDiscountFactorOffset: [],
			rateBucketId: []
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.rateSeason.rateSeasonDate = moment(this.rateSeason.rateSeasonDate).toDate();
	}

	categoryName(rateSeason: any) {
		if (rateSeason?.category) {
			const status = this.categories.find((e: any) => e.value == rateSeason.category);
			return status.name;
		}
		else {
			return '';
		}
	}

	rateBucketType(rateSeason: any) {
		if (rateSeason?.type) {
			const status = this.rateBucketTypes.find((e: any) => e.value == rateSeason.type);
			return status.name;
		}
		else {
			return '';
		}
	}

	increasePercentage(percentagefield, step) {
		let updatedValue = this.form1.value[percentagefield] + step;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}
	decreasePercentage(percentagefield, step){
		let updatedValue = this.form1.value[percentagefield] - step;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}

	getAllRateBuckets() {
		try {
			this.rateBucketService.getAllRateBuckets()
				.subscribe(
					res => {
						this.rateBuckets = res.data.rateBuckets;
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}
}
